import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

const GridWrapper = styled(Grid)`
  .video--media {
    height: 240px;
    position: relative;
    &.no--src {
      background-color: #e6e6e6;
      svg {
        width: 100%;
        height: 100%;
        color: #b8b8b8;
        position: absolute;
        left: 0;
      }
    }
  }
  .video--container {
    .video--title--wrapper {
      display: flex;
      align-items: center;
      .video--title {
        height: 29px;
        font-size: 21px;
        font-weight: 400;
        letter-spacing: 0.25px;
        color: RGBA(0, 0, 0, 0.87);
        margin-bottom: unset;
        padding-top: unset;
        width: 95%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        flex: 1 1 auto;
      }
      .video--trending {
        margin-left: 10px;
        color: RGB(0, 163, 184);
      }
    }
    .sub--title {
      min-height: 45px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -moz-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .video--action--wrapper {
      display: flex;
      flex: 1;
      align-items: center;
      .cta--wrapper {
        flex: 1 1 auto;
        .video--cta {
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 1.19px;
          line-height: 16px;
          width: 140px;
          height: 36px;
          color: ${(props) => props.theme.colors.primary.main};
        }
      }
      .video--cta--share {
        border-radius: 50% !important;
        padding: 6px;
      }
    }
    .video--tags--wrapper {
      margin-top: 15px;
      min-height: 38px;
      &.hasTags {
        cursor: move;
      }
      .react-multi-carousel-item {
        min-width: 60px;
        width: auto !important;
        margin: 0 6px;
        color: rgba(0, 0, 0, 0.87);
        background-color: rgba(0, 0, 0, 0.12);
        text-align: center;
        border-radius: 5px;
        &:first-child {
          margin-left: unset;
        }
        .video--tags {
          min-width: 60px;
          border-radius: 5px;
          cursor: move;
          user-select: none;

          &:hover {
            color: ${(props) => props.theme.colors.primary.main};
          }
        }
      }
    }
    .vjs-big-play-button {
      border-radius: 50% !important;
      z-index: 10;
    }

    iframe {
      width: 100%;
      height: 100%;

      &.vimeo-iframe {
        width: 101%;
        height: 101%;
      }
    }
  }

  .video--details {
    td {
      font-size: 12px;
      font-weight: 400;
      color: RGBA(0, 0, 0, 0.87);
      line-height: 16px;
    }
    .videoDetail {
      width: 100px;
    }
  }

  .coming--soon {
    position: absolute;
    top: calc(50% - 14px);
    text-align: center;
    width: 100%;
    z-index: 10;
    color: white;
    font-size: 16px;
    line-height: 28px;
    font-weight: 400;
    letter-spacing: 0.48px;
  }
  .gridContainer {
    padding: 0;
  }
  .grid {
    width: 98%;
    height: 558px;
    box-shadow: 0 0 7px 0 rgba(51, 51, 51, 0.33);
    margin: 10px 5px;
    padding: 15px;
    background-color: #fff;
    .gridPlayer {
      position: relative;
      max-width: 100%;
      height: 187px;
      .play-video-bt-grid,
      iframe {
        max-width: 100%;
      }
    }
    .videoTitle {
      margin-top: 15px;
    }

    .table-ellipsis {
      max-width: 170px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .media {
    height: 100%;
    width: 100%;
    max-width: 100%;
    position: relative;
    border-radius: 0px;
    opacity: 1;
    transition-duration: 0.3s;
    overflow: hidden;
    .media__wrapper {
      position: relative;
      height: 100%;
      width: 100%;
      cursor: pointer;
      border-radius: 0px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 1;
      padding-bottom: 56%;
      .video__container {
        position: absolute;
        width: 100%;
        min-width: 100%;
        padding-top: 0px;
        left: 0px;
        right: 0px;
        top: 0px;
        bottom: 0px;
        .video__overlay {
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.3);
          z-index: 2;
        }
        .video__mask {
          position: absolute;
          left: 0px;
          right: 0px;
          top: 0px;
          bottom: 0px;
          background-size: cover;
          background-position: center center;
        }
      }
    }

    .video__player {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      opacity: 1;
      &.in--play {
        .vjs-big-play-button {
          display: none;
        }
      }
      video {
        object-fit: cover;
      }

      .player__wrapper {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 1;

        .video-js {
          width: 100%;
          height: 100%;
          .vjs-big-play-button {
            top: 50%;
            left: 50%;
            width: 69px;
            height: 69px;
            line-height: 69px;
            border: none;
            border-radius: 50%;
            font-size: 3.5em;
            background-color: rgba(0, 0, 0, 0.3);
            color: #fff;
            -webkit-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
            -moz-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
            -ms-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
            -o-transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
            transition: border-color 0.4s, outline 0.4s, background-color 0.4s;
            position: absolute;
            &:hover {
              background-color: #f04d37;
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1091px) {
    .video--container {
      .video--action--wrapper {
        .cta--wrapper {
          .video--cta {
            width: auto;
          }
        }
      }
    }
  }

  @media screen and (min-width: 320px) and (max-width: 767px) {
    margin: auto !important;
    width: 100%;
    .coming--soon {
      font-size: 14px;
    }
    .grid {
      margin: 5px 0 !important;
      height: auto !important;
    }
    .no-description-grid p {
      margin-top: 0;
      height: auto !important;
      span {
        line-height: normal;
      }
    }
    .video--media {
      height: 144px;
    }
    .video--container {
      .MuiCardContent-root {
        padding: 10px;
      }
      .mobile--date {
        font-size: 10px;
      }
      .video--title--wrapper {
        position: relative;
        .video--title {
          font-size: 12px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -moz-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          white-space: unset;
        }
        .video--trending {
          position: absolute;
          font-size: 18px;
          top: -18px;
          right: 0;
        }
      }
      .sub--title {
        font-size: 11px;
        -webkit-line-clamp: 3;
      }

      .video--action--wrapper {
        height: 30px;
        .cta--wrapper {
          flex: unset;
        }
        svg {
          color: RGBA(0, 0, 0, 0.54);
          font-size: 18px;
        }
        .video--cta--share {
          margin-left: 30px;
        }
      }
    }
  }

  @media screen and (min-width: 320px) and (max-width: 368px) {
    .grid {
      height: 565px;
    }
  }
`;

export default GridWrapper;
